import axios from 'axios';

export const getEnv = () => {
    return axios.post('/wp-content/.env.json');
};
